// Simple shimmer skeleton. Background/animation defined in styles/patterns.css (.lk-skel).
// Usage:
//   <Skeleton w="100%" h={16} />
//   <Skeleton w={200} h={20} style={{ borderRadius: 10 }} />
export function Skeleton({ w = '100%', h = 16, radius, style, className = '', ...rest }) {
  const merged = {
    width: typeof w === 'number' ? `${w}px` : w,
    height: typeof h === 'number' ? `${h}px` : h,
    ...(radius != null ? { borderRadius: typeof radius === 'number' ? `${radius}px` : radius } : null),
    ...style,
  };
  return (
    <div
      className={`lk-skel ${className}`.trim()}
      aria-hidden="true"
      style={merged}
      {...rest}
    />
  );
}

// Convenience helpers
export function SkeletonText({ lines = 3, gap = 8, lastWidth = '60%' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap }} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} w={i === lines - 1 ? lastWidth : '100%'} h={12} />
      ))}
    </div>
  );
}

export function SkeletonRow({ cols = 4, height = 14 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: 12,
        padding: '10px 0',
      }}
      aria-hidden="true"
    >
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} h={height} />
      ))}
    </div>
  );
}

export default Skeleton;
